import { useLayoutEffect, useRef, useState } from 'react';

/** メニューを内包する最も近いスクロール/クリップ枠の下端（px）を返す。枠が無ければ画面下端。 */
function frameBottom(el: HTMLElement): number {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflow, overflowX, overflowY } = getComputedStyle(node);
    if (/(auto|scroll|hidden)/.test(overflow + overflowX + overflowY)) {
      return node.getBoundingClientRect().bottom;
    }
  }
  return window.innerHeight;
}

/**
 * ドロップダウンが枠下端で隠れる場合に上向きへ開くか判定するフック。
 * open=true でメニュー要素を測定し、下に収まらず上に余白がある場合のみ dropUp=true。
 * 返り値の menuRef を測定対象のメニュー要素に付与する。
 */
export function useDropUp(open: boolean) {
  const menuRef = useRef<HTMLDivElement>(null);
  const [dropUp, setDropUp] = useState(false);

  useLayoutEffect(() => {
    if (!open) {
      setDropUp(false);
      return;
    }
    const el = menuRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const margin = 16;
    const spaceBelow = frameBottom(el) - rect.top;
    // 下に収まらず、かつ上に十分な余白がある場合のみ上向きに開く
    if (spaceBelow < el.offsetHeight + margin && rect.top - el.offsetHeight - margin > 0) {
      setDropUp(true);
    }
  }, [open]);

  return { menuRef, dropUp };
}
